import React from 'react';
import { motion } from 'framer-motion';
import { Award, Clock, ShieldCheck, Blocks } from 'lucide-react';
export function WhyChooseUs() {
  const features = [{
    title: 'Experiencia comprobada',
    icon: <Award size={32} data-id="element-153" />,
    color: 'text-jml-blue',
    bg: 'bg-jml-blue/10',
    description: 'Más de 500 trabajos ejecutados y proyectos para empresas líderes respaldan nuestra operación.'
  }, {
    title: 'Cumplimiento de plazos',
    icon: <Clock size={32} data-id="element-154" />,
    color: 'text-jml-orange',
    bg: 'bg-jml-orange/10',
    description: 'Planificamos y ejecutamos con foco en cumplir tiempos, evitando retrasos y sobrecostos.'
  }, {
    title: 'Seguridad operativa',
    icon: <ShieldCheck size={32} data-id="element-155" />,
    color: 'text-green-500',
    bg: 'bg-green-500/10',
    description: '0 accidentes en 5 años, resultado de protocolos claros y supervisión constante.'
  }, {
    title: 'Solución integral',
    icon: <Blocks size={32} data-id="element-156" />,
    color: 'text-purple-500',
    bg: 'bg-purple-500/10',
    description: 'Un solo equipo para múltiples soluciones, evitando depender de varios contratistas.'
  }];
  return <section className="py-24 bg-navy-dark relative overflow-hidden" data-id="element-157">
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-158">
        <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=2070&auto=format&fit=crop" alt="Industrial Background" className="w-full h-full object-cover" data-id="element-159" />
        <div className="absolute inset-0 bg-navy mix-blend-multiply" data-id="element-160" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white font-heading" data-id="element-163">
            Por qué elegirnos
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-164">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy-light/90 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:-translate-y-2 transition-transform duration-300" data-id="element-165">
              <div className={`w-16 h-16 rounded-xl ${feature.bg} ${feature.color} flex items-center justify-center mb-6`} data-id="element-166">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 font-heading" data-id="element-167">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-168">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}